import { environment } from '@/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import { LoginLogs } from '@/app/models/interface/login-logs.model';
import {
  PaginatorModel,
  HasPagination,
} from '@/app/models/interface/paginator.model';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({ providedIn: 'root' })
export class LoginLogsService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'login-log';

  findAll(params: HttpParams) {
    return this.http
      .get<
        CustomResponse<PaginatorModel<LoginLogs[], HasPagination>>
      >(this.url, { params })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => data.result),
      );
  }
}
